<template>
  <div>
    <div class="d-flex align-center pb-1">
      <span class="font-14 font-weight-medium">Colunas</span>

      <v-spacer />

      <div class="w-250">
        <InputPesquisa v-model="pesquisa" />
      </div>
    </div>

    <div id="colunas-para-selecao" @dragover="ev => dragover(ev)">
      <div
        v-for="coluna in COLUNAS_COMPUTED"
        :key="coluna.value"
        class="coluna d-flex align-center"
        :draggable="true"
        @dragstart="ev => dragstart(ev, coluna)"
      >
        <div class="cursor-pointer mr-1" @click="selecaoColuna(coluna)">
          <v-icon v-if="colunaEstaSelecionada(coluna)" :size="17" color="primary">mdi-checkbox-marked</v-icon>
          <v-icon v-else :size="17">mdi-checkbox-blank-outline</v-icon>
        </div>

        {{ coluna.text }}
      </div>
    </div>
  </div>
</template>

<script>
import InputPesquisa from "./InputPesquisa.vue";

export default {
  name: "Colunas",
  components: {InputPesquisa},
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: Array,
    colunas: Array,
  },
  data: () => ({
    pesquisa: ''
  }),
  computed: {
    COLUNAS_COMPUTED() {
      if (typeof this.pesquisa !== 'string' || this.pesquisa.trim().length === 0) {
        return this.colunas;
      }

      const callback = coluna => {
        return coluna.text.toUpperCase().includes(this.pesquisa.toUpperCase());
      };

      return this.colunas.filter(callback);
    },
    COLUNAS_SELECIONDAS: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      }
    }
  },
  methods: {
    colunaEstaSelecionada(coluna) {
      return this.COLUNAS_SELECIONDAS.some(col => col.value === coluna.value);
    },
    removerColunaDaSelecao(coluna) {
      this.COLUNAS_SELECIONDAS = this.COLUNAS_SELECIONDAS.filter(col => col.value !== coluna.value);
    },
    selecaoColuna(coluna) {
      if (this.colunaEstaSelecionada(coluna)) {
        this.removerColunaDaSelecao(coluna);
      } else {
        this.COLUNAS_SELECIONDAS.push(coluna)
      }
    },
    dragstart(ev, coluna) {
      ev.dataTransfer.setData("text", JSON.stringify(coluna));
    },
    dragover(ev) {
      const coluna = JSON.parse(ev.dataTransfer.getData("text"));
      this.removerColunaDaSelecao(coluna);
    },
  }
}
</script>

<style scoped>
#colunas-para-selecao {
  height: 40vh;
  overflow-y: auto;
  background: #f5f5f5;
  padding: 3px 3px;
  border: 1px solid #e5e5e5;
  user-select: none;
}
#colunas-para-selecao .coluna {
  color: #1a1a1a;
  font-size: 12px;
  border: 1px solid #e5e5e5;
  margin: 0 0 3px 0;
  padding: 0 5px;
  background: #fdfdfd;
  user-select: none;
}
</style>
